export default function PHP_get_server_version() {
  return (
    <div>
      <h1>PHP_get_server_version</h1>
    </div>
  );
}
